export enum Einwilligung {
  persoenlicher_Kontakt,
  Einverstaendniserklaerung
}


// WEBPACK FOOTER //
// ./src/app/befreiung/shared/einwilligung.ts